import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    Renderer2,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {DialogDataService} from '../dialog/dialog-data.service';
import {RosterService} from '../shared/roster.service';
import {Roster, Student, StudentAddComment, StudentGradeStatement} from '../shared/interface/roster.interface';
import {ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {CourseService} from '../shared/course.service';
import {Course, CourseList} from '../shared/interface/course.interface';
import {GradeList, GradingRule, GradingRuleList} from '../shared/interface/grading-rule.interface';
import {GradingRuleService} from '../shared/grading-rule.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Md5} from 'ts-md5';
import {CourseCacheService} from '../shared/course-cache.service';
import {EnrollmentSourceService} from '../shared/enrollment-source.service';
import {GradeStatementScenarioType} from '../shared/enum/grade-statement-scenario-type';
import {GradeStatementService} from '../shared/grade-statement.service';
import {UserComment} from '../shared/interface/comment.interface';
import {EnrollmentSourceList, EnrollmentSourceRecord} from '../shared/interface/enrollment-source.interface';
import {
    GradeStatement,
    GradeStatementList,
    GradeStatementOption
} from '../shared/interface/grade-statement.interface';
import {AlertService} from '../shared/services/alert.service';
import {ReflectionService} from '../shared/utilities/reflection.service';
import {GradeStatementComponent} from './grade-statement/grade-statement.component';
import {RosterAddCommentComponent} from './roster-add-comment/roster-add-comment.component';
import {RosterViewCommentComponent} from './roster-view-comment/roster-view-comment.component';
import {DatePipe, formatDate} from '@angular/common';
import {GenericFormGroupComponent} from '../forms/generic-form-group.component';
import {CourseDialogData} from './roster.types';
import {GradingScheduleList} from '../shared/interface/grading-schedule.interface';
import {RosterViewGradeChangeComponent} from './roster-view-grade-change/roster-view-grade-change.component';
import {GradeStatementOptionMessageType} from '../shared/enum/grade-statement-option-message-type';
import {UserInfo} from '../core/ucr-security/user-info';
import {Roles} from '../core/ucr-security/roles';
import {UcrSecurityService} from '../core/ucr-security/ucr-security.service';
import {GradingScheduleService} from '../shared/grading-schedule.service';
import {GradeChangeCodeMapService} from '../shared/grade-change-code-map.service';
import {GradeChangeCodeMap} from '../shared/interface/grade-change-code-map.interface';
import {HealthService} from '../shared/services/health.service';

export const browserRefresh = false;

@Component({
    selector: 'app-object-list-roster',
    templateUrl: './roster.component.html',
    styleUrls: ['./roster.component.scss']
})
export class RosterComponent extends GenericFormGroupComponent implements OnInit {
    displayedColumns: string[] = [
        'name',
        'pronouns',
        'studentId',
        'numUnit',
        'gradeBanner',
        'gradeIGrade',
        'gradeRule',
        'gradeType',
        'enrollmentSource',
        'addNotes',
        'viewNotes',
        'gradeHistory'
    ];

    todayDate: number;
    pipe: DatePipe;
    gradeScheduleInFuture: boolean = false;
    termCode: string;
    crn: string;
    currentCourse: Course;
    isDataLoaded: boolean = false;
    validGradeList: Array<GradingRule>;
    gradeStatementList: GradeStatementList;
    mainValidationErrorMessage: string;
    pagingSizeList: number[] = [];
    numPerPage: number = 25;
    searchText: string;
    searchEnrollment: string = 'All Students';
    searchGrade: string;
    enrollmentSourceList: Array<EnrollmentSourceRecord>;
    studentExistsInDataSource: boolean = false;
    isHiddenForRole: boolean = true;
    readOnlyMode: boolean = false;
    studentListForExchange: Student[];
    gradeListGD: Array<GradeList> = [];
    gradeListIP: Array<GradeList> = [];
    gradeListI: Array<GradeList> = [];
    readonly defaultSearchListText: string = 'all students';
    readonly searchByText: string = 'searchText';
    readonly searchByEnrollment: string = 'searchEnrollment';
    readonly searchByGrade: string = 'searchGrade';
    readonly resetAllSearch: string = 'resetAllSearch';

    public dataSource: MatTableDataSource<Student>;

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    @Input() inTermCode: string;
    @Input() inCrn: string;
    @Input() inIPGrading: boolean;
    @Output() dataSourceStudentList = new EventEmitter<Student[]>();

    readonly gradeStatementScenarioType: GradeStatementScenarioType = GradeStatementScenarioType.getInstance();
    readonly gradeStatementOptionMessageType: GradeStatementOptionMessageType =
        GradeStatementOptionMessageType.getInstance();

    showToolBar: boolean = true;
    showForNonIPGrade: boolean = true;
    readonly roles = Roles;
    userInfo: UserInfo;
    gradeSchedule: GradingScheduleList;

    constructor(
        public health: HealthService,
        public dialog: MatDialog,
        public datePipe: DatePipe,
        public ucrSecurity: UcrSecurityService,
        public rosterService: RosterService,
        public courseCacheService: CourseCacheService,
        private route: ActivatedRoute,
        private router: Router,
        public courseService: CourseService,
        private gradingRuleService: GradingRuleService,
        private gradeStatementService: GradeStatementService,
        private alertService: AlertService,
        private dataService: DialogDataService<CourseDialogData>,
        private reflection: ReflectionService,
        public enrollmentSourceService: EnrollmentSourceService,
        private alert: AlertService,
        protected renderer2: Renderer2,
        private changeDetectRef: ChangeDetectorRef,
        private gradingScheduleService: GradingScheduleService,
        private gradeChangeCodeMapService: GradeChangeCodeMapService
    ) {
        super(renderer2);
    }

    ngOnInit() {
        // get grading list

        this.ucrSecurity.getUserInfo().subscribe((ui: UserInfo) => {
            this.userInfo = ui;
            if (
                ui.ifAnyGranted([this.roles.switchUser]) &&
                ['development'].indexOf(this.health.currentHealthData.environment) >= 0
            ) {
                this.isHiddenForRole = false;
            } else {
                this.isHiddenForRole = true;
            }
        });

        this.gradeStatementService.get().subscribe((response: GradeStatementList) => {
            this.gradeStatementList = response;
        });

        //get term code and crn
        this.termCode = this.route.snapshot.paramMap.get('termCode');
        this.crn = this.route.snapshot.paramMap.get('crn');
        if (
            this.reflection.isNullOrEmpty(this.termCode) &&
            this.reflection.isNullOrEmpty(this.crn) &&
            this.reflection.isNotNullOrEmpty(this.dataService?.data?.termCode) &&
            this.reflection.isNotNullOrEmpty(this.dataService?.data?.crn)
        ) {
            this.termCode = this.dataService.data.termCode;
            this.crn = this.dataService.data.crn;
            this.readOnlyMode = this.dataService.data.readonly;
            this.showToolBar = false;
        }

        if (this.inTermCode) {
            this.termCode = this.inTermCode;
            this.crn = this.inCrn;
        }

        this.getCourse(this.termCode, this.crn);
        // get current course info from cache

        // double check if we have course if not set it is not there
        if (this.currentCourse?.crn !== this.crn) {
            this.currentCourse = undefined;
        }

        // load grading rules
        this.gradingRuleService.get().subscribe((response: GradingRuleList) => {
            if (response.list.length > 0) {
                this.validGradeList = response.list;
                this.gradingRuleService.setCurrentGradingList(response.list);
            }
        });

        this.enrollmentSourceService.get().subscribe((response: EnrollmentSourceList) => {
            if (response.list.length > 0) {
                this.enrollmentSourceList = response.list;
            }
        });

        this.getRoster(this.termCode, this.crn);

        this.getScheduleData(this.termCode);
    }

    getScheduleData(termCode: string) {
        if (termCode) {
            this.gradingScheduleService.get(termCode).subscribe((response: GradingScheduleList) => {
                this.gradeSchedule = response[0];

                this.pipe = new DatePipe('en-US');

                this.todayDate = Number(this.pipe.transform(new Date(), 'yyyyMMddHHmmss', 'en-US'));

                console.log(this.todayDate);
                console.log(Number(this.pipe.transform(this.gradeSchedule.openDate, 'yyyyMMddHHmmss', 'en-US')));
                if (Number(this.pipe.transform(this.gradeSchedule.openDate, 'yyyyMMddHHmmss', 'en-US')) > this.todayDate) {
                    this.gradeScheduleInFuture = true;
                }
                console.log(this.gradeScheduleInFuture);
            });
        }
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.changeDetectRef.detectChanges();
    }

    setListGD() {
        this.gradingRuleService.getGradeListGD()?.subscribe((response: Array<GradeList>) => {
            this.gradeListGD = response;
        });
    }

    setListI() {
        this.gradingRuleService.getGradeListI()?.subscribe((response: Array<GradeList>) => {
            this.gradeListI = response;
        });
    }

    setListIP() {
        this.gradingRuleService.getGradeListIP()?.subscribe((response: Array<GradeList>) => {
            this.gradeListIP = response;
        });
    }

    getPagingSize(totalNumRecords: number): number[] {
        const returnPagingSizeList: number[] = [];
        if (totalNumRecords > this.numPerPage) {
            for (let i = 1; i < totalNumRecords; i++) {
                if (i % this.numPerPage === 0) {
                    returnPagingSizeList.push(i);
                }
            }
        }

        returnPagingSizeList.push(totalNumRecords);

        return returnPagingSizeList.filter((v, i, a) => a.indexOf(v) === i).sort((a, b) => a - b);
    }

    setDataSource(studentList: Student[]) {
        this.isDataLoaded = false;
        const paginatorBox = document.getElementById('rosterPaginator');
        if (studentList.length > 0) {
            this.studentExistsInDataSource = true;
            paginatorBox.classList.remove('do-not-show');
        } else {
            this.studentExistsInDataSource = false;
            paginatorBox.classList.add('do-not-show');
        }

        this.dataSource = new MatTableDataSource<Student>(studentList);

        this.dataSource.sortingDataAccessor = (item: Student, property: string) => {
            switch (property) {
                case 'name':
                    return item.bannerLastName.toLowerCase() + item.bannerFirstName.toLowerCase();
                default:
                    return item[property];
            }
        };
        this.dataSource.sort = this.sort;
        this.pagingSizeList = this.getPagingSize(studentList.length);
        this.paginator.pageSizeOptions = this.pagingSizeList;
        this.paginator.pageSize = studentList.length > this.numPerPage ? this.numPerPage : studentList.length;
        this.dataSource.paginator = this.paginator;

        this.emitDataSource();
        this.isDataLoaded = true;
    }

    getRoster(termCode: string, crn: string, ignoreCache: boolean = false) {
        this.isDataLoaded = false;
        this.setListIP();
        this.setListGD();
        this.setListI();

        this.rosterService.get(termCode, crn)?.subscribe((response: Roster) => {
            //set roster
            this.rosterService.setCurrentRoster(response); //this will also do the sort
            let dataSourceStudentList = [];
            const listGradeExcludeForIP = this.gradeListIP.concat(this.gradeListGD.concat(this.gradeListI));
            const studentList = this.rosterService.currentRoster?.roster;
            const localRosterService = this.rosterService;

            studentList.forEach((student: Student) => {
                if (student.changeHistory.length > 0) {
                    student.changeHistoryLog = student.changeHistory.split(',');
                }
            });

            if (this.inIPGrading) {
                /**
                 * for IP grading filter out students with IP grade.
                 */
                dataSourceStudentList = studentList.filter(function (item: Student) {
                    if (!localRosterService.isGradingIP(true, listGradeExcludeForIP, item)) {
                        return item;
                    }
                });
            } else {
                dataSourceStudentList = studentList;
            }
            this.setDataSource(dataSourceStudentList);
            this.searchEnrollment = 'All Students';
            this.updateSearchByEnrollmentSource();
        });
    }

    getCourse(termCode: string, crn: string) {
        this.currentCourse = this.courseService.getCurrentCourse();

        if (!this.currentCourse || this.currentCourse.termCode != termCode || this.currentCourse.crn != crn) {
            this.courseService.getByCRN(termCode, crn).subscribe((response: CourseList) => {
                if (response.list.length > 0) {
                    let course = response.list[0];
                    console.log(course);
                    if (this.userInfo) {
                        if (
                            response?.list?.find((m) => {
                                return m.instructorNetId === this.userInfo.username;
                            })
                        ) {
                            course = response?.list?.find((m) => {
                                return m.instructorNetId === this.userInfo.username;
                            });
                            console.log(course);
                        }
                    }
                    console.log(course);
                    this.currentCourse = course; // get the first one.  when search by crn it is always the 0 index
                    this.courseService.setCurrentCourse(course);
                }
            });
        }
    }

    getValidGradingList(gradeLevel: string, gradeMode: string) {
        return this.gradingRuleService
            .getValidGradingList(gradeLevel, gradeMode)
            ?.sort((a: GradingRule, b: GradingRule) => a.sortOrder - b.sortOrder);
    }

    updateGradeChangeCode(student: Student) {
        this.gradeChangeCodeMapService
            .get(
                student.gradeBanner ? student.gradeBanner : null,
                student.gradeIGrade ? student.gradeIGrade : null,
                student.shrtckgGCHGCode ? student.shrtckgGCHGCode : null,
                student?.gradeResponse?.selectedMessageType
            )
            .subscribe((response: GradeChangeCodeMap) => {
                student.gradeChangeCodeMap = response;
            });
    }

    removeADNotes(student: Student) {
        // only delete old comment if it the previous
        // was added GD grade not last grade chagne
        // need to track if GD was every requested.
        // if yes and grade change this comment removed
        //remove that flag of GD

        if (!student.gdGradeIssuedInSession) {
            return;
        }

        // student.gdGradeIssuedInSession is true
        if (
            !student.gradeResponse.selectedGradeStatementScenarioType ||
            student.gradeResponse.selectedGradeStatementScenarioType !==
            this.gradeStatementScenarioType.gdGradeScenarioInitialGrade
        ) {
            let studentCommentList: Array<UserComment>;
            const gradeStatementScenarioType = this.gradeStatementScenarioType;

            // eslint-disable-next-line prefer-const
            studentCommentList = student.comment.filter(function (item: UserComment) {
                return item.comment == gradeStatementScenarioType.gdGradeScenarioInitialGrade.comment;
            });

            studentCommentList.sort(function (a: UserComment, b: UserComment) {
                return b.id - a.id;
            });

            const userCommentToDelete = studentCommentList.find((item: UserComment) => {
                return (item.id = studentCommentList.reduce((a, b) => Math.max(a, b.id), -Infinity));
            });

            const index = student.comment.indexOf(userCommentToDelete, 0);

            this.rosterService
                .deleteOneStudentComment(student, userCommentToDelete)
                .subscribe((result: StudentAddComment) => {
                });

            if (index > -1) {
                student.comment.splice(index, 1);
                student.gdGradeIssuedInSession = false;
            }
            this.dataSource.data.find((dataStudent) => dataStudent.studentId == student.studentId).comment =
                student.comment;
        }
    }

    setSelectedGrade(student: Student) {
        student.gradeLastSelected = student.gradeIGrade;
        this.updateGradeChangeCode(student);
        this.removeADNotes(student);
    }

    showCustomStatement(student: Student, selectedGrade: string) {
        //initialize student respon

        const localStatement: GradeStatement = this.gradeStatementService.findStatement(
            student,
            this.gradeStatementList
        );

        if (localStatement) {
            student.gradeResponse = {
                agree: false,
                gradeStatementOptionId: -1,
                selectedMessageType: null,
                selectedGradeStatementScenarioType: null
            };

            const data: StudentGradeStatement = {
                student: student,
                gradeStatement: localStatement
            };
            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = data;
            dialogConfig.disableClose = true;
            const dialogRef = this.dialog.open(GradeStatementComponent, dialogConfig);

            dialogRef.afterClosed().subscribe((result) => {
                //restore grade if not agree
                if (!student.gradeResponse.agree) {
                    student.gradeIGrade = student.gradeOriginalIGrade;
                } else {
                    //find if there is a change code if not don't proceed
                    if (student.shrtckgGCHGCode) {
                        const optionSelected = localStatement.gradeStatementText.gradeStatementOption.find(
                            (item: GradeStatementOption) => {
                                return item.id === student.gradeResponse.gradeStatementOptionId;
                            }
                        );
                        student.gradeResponse.selectedMessageType = optionSelected.messageType;

                        if (
                            optionSelected.messageType ==
                            this.gradeStatementOptionMessageType.PastStudentWorkCompleteAfterExtension
                        ) {
                            student.gradeIGrade = student.gradeOriginalIGrade;
                            student.gradeResponse.gradeStatementOptionId = null;
                        } else {
                            // not restore original grade add comment
                            student.tempComment = optionSelected.statement;
                        }
                    }

                    this.setSelectedGrade(student);
                    this.addNotes(student, false);
                }
            });
        } else {
            this.setSelectedGrade(student);
        }

        this.emitDataSource();
    }

    //add notes to the list
    addNotes(student: Student, canDelete: boolean = true) {
        // set up temp user comment
        //call service to pull the data and update the comment information
        this.rosterService.addOneStudentComment(student, canDelete).subscribe((response: StudentAddComment) => {
            const returnData = response?.list;
            student.tempComment = null;
            this.dataSource.data.find((student) => student.studentId == returnData.studentId).comment =
                returnData.comment;
        });
    }

    //delete temp notes (clear the text area)
    clearNotes(student: Student) {
        student.tempComment = null;
    }

    //pop up a window to show the notes
    showAddNotes(student: Student) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = student;
        dialogConfig.disableClose = false;
        const dialogRef = this.dialog.open(RosterAddCommentComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((result) => {
            this.addNotes(result, true);
            this.emitDataSource();
        });
    }

    //pop up a window to show the notes
    showAllNotes(student: Student) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = student;
        dialogConfig.disableClose = false;
        const dialogRef = this.dialog.open(RosterViewCommentComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((result) => {
            this.emitDataSource();
        });
    }

    viwGradeChangeHistory(student: Student) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = student;
        dialogConfig.disableClose = false;
        const dialogRef = this.dialog.open(RosterViewGradeChangeComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((result) => {
            this.emitDataSource();
        });
    }

    sendButtonNewRoster(status: boolean) {
        if (status && this.dataSource) {
            this.studentListForExchange = this.dataSource?.data;
        }
    }

    onSaveGrade(saveStatus: boolean) {
        this.setSaving();
        this.isDataLoaded = false;
        this.rosterService.update(this.rosterService.currentRoster.id, this.dataSource.data).subscribe({
            next: (response: Roster) => {
                this.setDoneSaving();
                this.rosterService.setCurrentRoster(response); //this will also do the sort
                if (response.list.length > 0) {
                    this.alertService.toastSuccess('Saved.');
                    this.getRoster(this.termCode, this.crn);
                } else {
                    this.alertService.toastWarn('Not Saved.');
                }
            },
            error: (err) => {
                this.setDoneSaving();
                this.alert.toastErrorObject(err);
            }
        });
        this.isDataLoaded = true;
    }

    onValidateGrade(mainValidationErrorMessage: Array<String>) {
        this.isDataLoaded = false;
        this.alertService.info({
            title: 'Success',
            text: mainValidationErrorMessage.join('\n\n')
        });
        this.getRoster(this.termCode, this.crn, true);
        //this.mainValidationErrorMessage = mainValidationErrorMessage;
    }

    setIsDataLoadedSubmitButton(status: boolean) {
        this.isDataLoaded = status;
    }

    resetSearchText(searchBy: string) {
        switch (searchBy) {
            case this.searchByText: {
                this.searchGrade = this.defaultSearchListText;
                this.searchEnrollment = this.defaultSearchListText;
                break;
            }
            case this.searchByGrade: {
                this.searchText = '';
                this.searchEnrollment = this.defaultSearchListText;
                break;
            }
            case this.searchByEnrollment: {
                this.searchText = '';
                this.searchGrade = this.defaultSearchListText;
                break;
            }
            case this.resetAllSearch: {
                this.searchText = '';
                this.searchGrade = this.defaultSearchListText;
                this.searchEnrollment = this.defaultSearchListText;
                break;
            }
        }
    }

    resetFilterPredicate() {
        this.dataSource.filterPredicate = function (data, filter) {
            const dataStr = Object.keys(data)
                .reduce(function (currentTerm, key) {
                    return currentTerm + data[key];
                }, '')
                .toLowerCase();
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) != -1;
        };
    }

    updateSearchByText() {
        this.resetFilterPredicate();
        this.resetSearchText(this.searchByText);
        const searchText = this.searchText.toLowerCase();

        this.dataSource.filter = searchText;
    }

    /**
     * search by grade has grade or no grade
     */
    updateSearchByGrades() {
        this.resetSearchText(this.searchGrade);
        let searchText = '0';

        console.log(this.searchGrade?.toLowerCase());

        switch (this.searchGrade?.toLowerCase()) {
            case 'Students does not have iGrade'.toLowerCase():
                this.dataSource.filterPredicate = (data: Student, filter: string) => {
                    return data.gradeIGrade?.length?.toString() == filter;
                };
                break;
            case 'Students have iGrade'.toLowerCase():
                this.dataSource.filterPredicate = (data: Student, filter: string) => {
                    return data.gradeIGrade?.length?.toString() != filter;
                };
                break;
            default:
                searchText = '';
                break;
        }

        this.dataSource.filter = searchText;
    }

    /**
     * filter by enrollment source
     */
    updateSearchByEnrollmentSource() {
        this.resetSearchText(this.searchByEnrollment);
        let searchText = this.searchEnrollment.toLowerCase();

        // @ts-ignore
        searchText =
            this.searchEnrollment.toLowerCase() != this.defaultSearchListText
                ? this.searchEnrollment.toLowerCase()
                : null;

        this.dataSource.filterPredicate = (data: Student, filter: string) => {
            return data.enrollmentSource.toLowerCase() == filter;
        };
        this.dataSource.filter = searchText;
    }

    /**
     * reset filters
     */
    updateSearchClear() {
        this.resetSearchText(this.resetAllSearch);
        this.dataSource.filter = null;
    }

    emitDataSource() {
        this.dataSourceStudentList.emit(this.dataSource?.data);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.inIPGrading) {
            this.showToolBar = false;
            this.showForNonIPGrade = false;
            this.displayedColumns = [
                'name',
                'pronouns',
                'studentId',
                //'numUnit',
                'gradeBanner',
                'gradeIGrade',
                'gradeRule',
                'gradeType',
                //'enrollmentSource',
                //'addNotes',
                'viewNotes',
                //'gradeHistory'
            ];

        }

        if (changes.inTermCode || changes.inCrn) {
            this.termCode = this.inTermCode;
            this.crn = this.inCrn;
            this.getCourse(this.termCode, this.crn);
            this.getRoster(this.termCode, this.crn);
        }

        this.getScheduleData(this.termCode);
    }

    cannotModifyReason(student: Student) {
        const reasonList = [];
        let returnStr: string = '';

        if (student.hasGraduated) {
            reasonList.push(
                "This student has graduated and their grades cannot be updated. Please contact the Registrar's Office for more information."
            );
        }

        if (student.numberOfGradeChange > student.maxNumberGradeChange) {
            reasonList.push(
                'Number of grade change for student (' +
                student.numberOfGradeChange +
                ') has reach the maximum number of grade change allowed  (' +
                student.maxNumberGradeChange +
                ').'
            );
        }

        returnStr = reasonList.join('\n');
        return returnStr;
    }
}
